module.exports = __webpack_public_path__ + "static/media/vanilla-sky-poster.4733534c.jpg";